import PaymentWrapperWithModal from 'Components/Payment/PaymentWrapperWithModal'
import { useEffect } from 'react'
import { stripeService } from 'store'

import { Elements } from '@stripe/react-stripe-js'

const PaymentContainer = () => {
  useEffect(() => {
    // Users can reach to the payment screen from different places. We want to use this as an umbrella event.
    // E.g, as an activation event in growthbook
    logEvent('web_paymentMounted')
  }, [])

  return (
    <Elements stripe={stripeService}>
      <PaymentWrapperWithModal />
    </Elements>
  )
}

export default PaymentContainer
